import {defaultTheme} from '@stencil/build-theme/src/build-theme';
import HappyCloseIcon from '@stencil/icons/src/HappyCloseIcon/HappyCloseIcon';
import * as S from './PolicyModal.styles';
import * as P from './Policy.styles';
import {
  BaseColumnWrap,
  SectionHeader,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {getHouseRuleIcon} from '../../../../../shared/pages/DetailsPageNew/utils/details-page-utils';

// Components
const noop = () => {};
const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3.4,
  slidesToScroll: 1,
};
const HotelPolicyModal = ({closeModal = noop, houseRules}) => {
  if (!houseRules) return null;

  return (
    <>
      <S.RoomDetailsHeaderWrap>
        <SectionHeader>Property Policies</SectionHeader>
        <HappyCloseIcon
          height="2rem"
          width="2rem"
          fill={defaultTheme.colors.downriver.base}
          onClick={closeModal}
        ></HappyCloseIcon>
      </S.RoomDetailsHeaderWrap>
      {/* HOUSE RULES */}
      <S.RoomAmenitiesBodyWrap>
        {houseRules?.map((headerRule, index) => {
          if (!headerRule?.rules?.length) return;
          return (
            <S.HouseRulesList>
              <BaseColumnWrap>
                <S.PolicyListHeading>{headerRule?.category}</S.PolicyListHeading>
                <S.FeatureListUL>
                  {headerRule?.rules?.map((rule, index) => (
                    <li>
                      <S.IconWrap>{getHouseRuleIcon(rule?.values?.[0])}</S.IconWrap>
                      <S.ListPara dangerouslySetInnerHTML={{__html: rule?.text}}></S.ListPara>
                    </li>
                  ))}
                </S.FeatureListUL>
              </BaseColumnWrap>
            </S.HouseRulesList>
          );
        })}
      </S.RoomAmenitiesBodyWrap>
    </>
  );
};
export default HotelPolicyModal;
